<div class="flex flex-col items-center justify-center">
  <div class="flex flex-col gap-4 md:gap-6 text-center">
    <i nz-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <mask
          id="mask0_13499_289364"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="48"
        >
          <rect width="48" height="48" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_13499_289364)">
          <path
            d="M22.2 33.2L36.3 19.1L33.5 16.3L22.2 27.6L16.5 21.9L13.7 24.7L22.2 33.2ZM25 44C22.2333 44 19.6333 43.475 17.2 42.425C14.7667 41.375 12.65 39.95 10.85 38.15C9.05 36.35 7.625 34.2333 6.575 31.8C5.525 29.3667 5 26.7667 5 24C5 21.2333 5.525 18.6333 6.575 16.2C7.625 13.7667 9.05 11.65 10.85 9.85C12.65 8.05 14.7667 6.625 17.2 5.575C19.6333 4.525 22.2333 4 25 4C27.7667 4 30.3667 4.525 32.8 5.575C35.2333 6.625 37.35 8.05 39.15 9.85C40.95 11.65 42.375 13.7667 43.425 16.2C44.475 18.6333 45 21.2333 45 24C45 26.7667 44.475 29.3667 43.425 31.8C42.375 34.2333 40.95 36.35 39.15 38.15C37.35 39.95 35.2333 41.375 32.8 42.425C30.3667 43.475 27.7667 44 25 44Z"
            fill="#0D9443"
          />
        </g>
      </svg>
    </i>
    <h4 class="paragraph-large bold mb-2">{{ 'profile.documentsReceived' | translate }}</h4>
    <p class="paragraph-medium regular text-center">
      {{ 'profile.yourAccountDetails' | translate }}
    </p>
  </div>
</div>
<div *nzModalFooter class="flex justify-center">
  <korviu-button size="small" color="tertiary" (click)="onContinueClick()" class="w-full">
    {{ 'common.continue' | translate }}
  </korviu-button>
</div>
